import * as React from 'react';
import { useDispatch } from 'react-redux';

/**
 * Dispatch one of two actions passed in based on whether or not
 * the current URL matches the new URL.
 * @param path The URL path to try and match against
 * @param matchAction The redux action to dispatch in the 
 *                    event of a success
 * @param missAction The redux action to dispatch in the 
 *                    event of no match
 */
export function useSearchParams(path : string, matchAction : any, missAction : any) {

    const dispatch = useDispatch();
    const [initRoute, setInitRoute] = React.useState<string>();

    React.useEffect(() => {
        setInitRoute(document.location.pathname);
    }, []);

    React.useEffect(() => {
        return () => {

            const newRoute = document.location.pathname;
            if (initRoute && newRoute !== initRoute) {
                if (document.location.pathname.indexOf(path) > -1) {
                    if (matchAction) {
                        dispatch(matchAction);
                    }
                }
                else {
                    if (missAction) {
                        dispatch(missAction);
                    }
                }
            }
        };
    });

    return;
}
